// @flow strict

export function backgroundImage(src: string): ?{backgroundImage: string} {
  if (src) {
    return {
      backgroundImage: `url(${src})`,
    };
  }
}
